export default "__VITE_ASSET__8a0808fd__"